/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAgencyEmployeeRequest
 */
export interface CreateAgencyEmployeeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAgencyEmployeeRequest
     */
    firstname: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgencyEmployeeRequest
     */
    lastname: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAgencyEmployeeRequest
     */
    externalId?: string;
}

/**
 * Check if a given object implements the CreateAgencyEmployeeRequest interface.
 */
export function instanceOfCreateAgencyEmployeeRequest(value: object): value is CreateAgencyEmployeeRequest {
    if (!('firstname' in value) || value['firstname'] === undefined) return false;
    if (!('lastname' in value) || value['lastname'] === undefined) return false;
    return true;
}

export function CreateAgencyEmployeeRequestFromJSON(json: any): CreateAgencyEmployeeRequest {
    return CreateAgencyEmployeeRequestFromJSONTyped(json, false);
}

export function CreateAgencyEmployeeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAgencyEmployeeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstname': json['firstname'],
        'lastname': json['lastname'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
    };
}

export function CreateAgencyEmployeeRequestToJSON(value?: CreateAgencyEmployeeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'firstname': value['firstname'],
        'lastname': value['lastname'],
        'externalId': value['externalId'],
    };
}

